module.exports = __webpack_public_path__ + "static/LTCBod175Rom-5892a827d87b3b1e48b7f88413922222.woff";